<template>
    <div class="acc-height mb-2">
        <h3 class="mb-4 pl-4 hide-in-modal">
            ПОЛИТИКА ЗА ИЗПОЛЗВАНЕ НА „БИСКВИТКИ“ В<br>
            АдминСофт и АдминСофт Плюс
        </h3>
        <p class="hide-in-modal">На този уебсайт се използват бисквитки.</p>
        <p class="mb-0"><strong>Какво представляват бисквитките (cookies)?</strong></p>
        <p>
            Те са кратка информация, която този уебсайт записва на компютъра или мобилното устройство на посетителя. Те
            позволяват на уебсайта да запаметява вашите действия и предпочитания (като например потребителско име,
            език, размер на шрифта и други настройки за показване) за определен период от време, за да не се налага да
            ги въвеждате всеки път, когато посещавате сайта или преминавате от една страница към друга.
        </p>
        <p class="mb-0"><strong>Как използваме бисквитките?</strong></p>
        <p class="mb-0">
            „Бисквитките“, използвани от „АдминСофт“ и „АдминСофт Плюс“, са свързани единствено с предоставяне на услуги
            от разстояние чрез използването на електронни средства, след изрично изявление от страна на получателя на
            услугата. Тъй като ценим Вашето доверие, Ви предоставяме информация за целите, основанията и категориите
            данни, които събираме чрез „бисквитките“.
        </p>
        <p class="mb-0">
            Използваме „бисквитки“ за постигането на следните легитимни цели:
        </p>
        <ul class="mb-0">
            <li>
                Идентифициране на ползвателите на нашите услуги („бисквитки“ за идентифициране), когато влизат със своя
                профил в нашите системи. По този начин те изрично искат достъп до съдържанието или функцията, за която
                имат разрешение. Тези бисквитки се наричат „сесийни“.
            </li>
            <li>
                Повишаване на сигурността на услугите, изрично поискана от ползвателя („бисквитки“ за сигурност). Такива
                например са „бисквитките“, които се използват за откриване на последователни неуспешни опити за влизане
                в даден профил, софтуерен токен или други подобни механизми, предназначени да защитят входа в системата
                от злоупотреби. Тези механизми имат по-дълъг жизнен цикъл, за да постигнат защитната си цел.
            </li>
        </ul>
        <p class="mb-0">
            Използваме бисквитките на първа страна. Това са бисквитки, които се създават от уебсайта, който посещавате с
            оглед ползването на услугата. Само този уебсайт може да ги дешифрира. Използваните от нас бисквитки могат да
            бъдат за по-дълъг срок (в зависимост от предоставяната функция, но не по-дълъг от 2 дни) и сесийни.
            Сесийните се изтриват автоматично, когато затворите браузъра си. Бисквитките за по-дълъг срок се използват
            само за повторното Ви идентифициране при следващото Ви посещение на сайта, но не по-дълго от 2 дни.
        </p>
        <p>
            Използваните от нас бисквитки са строго необходими за услугите, за които сте направили регистрация и
            използвате по силата на договори, сключени с „АдминСофт“ / „АдминСофт Плюс“ или с образователните
            институции, в които работите, учите или учат Вашите деца. Поради това сме взели всички необходими мерки
            жизненият цикъл на бисквитките, които използваме, да е програмиран така, че да се заличава, когато вече не е
            нужен за целите на договора.
        </p>
        <p class="mb-0"><strong>Как използваме бисквитките?</strong></p>
        <p>
            Може да контролирате и изтривате бисквитките по всяко време (за повече информация вижте <a
                href="https://aboutcookies.org/"
                target="_blank">aboutcookies.org</a>).
            Браузърите могат да бъдат настроени автоматично да изтриват бисквитките, а също така можете да изтривате
            ръчно всички или определени бисквитки. Обърнете внимание, че някои функции
            няма да работят, а други ще трябва да настройвате всеки път, когато посещавате уебсайта, ако извършите това/тези действие/я.
        </p>
        <p class="mb-0"><strong>За контакти</strong></p>
        <p>Конкретни въпроси за съхранението и използването на данни от „бисквитките“, които могат да се отнасят до Вас,
            може да изпращате на адрес cookies@adminplus.bg</p>
    </div>
</template>

<script>
    export default {
        name: "gdpr-cookies-text"
    }
</script>

<style scoped>

</style>
